import styled from 'styled-components'
import Icon from '@/components/icon'

export const BadgeIcon = styled(Icon)`
  width: ${({ width }) => width || 16}px;
  height: ${({ height }) => height || 16}px;
  flex-shrink: 0;
  margin-top: ${({ top }) => top || 0}px;
  margin-right: ${({ right }) => right || 0}px;
  margin-bottom: ${({ bottom }) => bottom || 0}px;
  margin-left: ${({ left }) => left || 0}px;
`
